import { useState } from "react";
import { BTN_TXT } from "../../constants/constants";

const DEFAULT_TRUNCATE_LENGTH = 100;

const ExpandableText = ({
  text,
  className = "",
  textClassName = "",
  toggleClassName = "read-more-toggle",
  truncateLength = DEFAULT_TRUNCATE_LENGTH,
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) {
    return null;
  }

  const isTruncatable = text.length > truncateLength;
  const displayText =
    !isTruncatable || expanded
      ? text
      : `${text.slice(0, truncateLength)}...`;

  return (
    <div className={className}>
      <span className={textClassName}>{displayText}</span>
      {isTruncatable ? (
        <button
          type="button"
          className={toggleClassName}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? BTN_TXT.READ_LESS : BTN_TXT.READ_MORE}
        </button>
      ) : null}
    </div>
  );
};

export default ExpandableText;
